import React, { useEffect, useRef, useState, useCallback } from "react";
import axios from "axios";
import InviteInput from "./InviteInput.jsx";
import CartItems from "./CartItems.jsx";
import { Tooltip } from 'react-tooltip'
import Totals from "./Totals.jsx";
import CrewCartItemOverView from "./CrewCartItemOverView.jsx";
import { useTranslation } from 'react-i18next';
import crewCartMember from "./CrewCartMember.jsx";
import CartButtons from './CartButtons';

const CartOverView = ({ crewCart, currencyFormatter, rootUrl, resizeIframe, userToken, crewCartToken, crewcartMember }) => {
    const { t } = useTranslation();
    const [checkoutDisabled, setCheckoutDisabled] = useState(false);

    const [shoppingComplete, setShoppingComplete] = useState(false);
    const [loading, setLoading] = useState(false);



    return (<div>
            <CrewCartItemOverView crewCart={crewCart} currencyFormatter={currencyFormatter} />
        </div>
    );
}
export default CartOverView;
